import { baseApi } from '../axios';

export const getOpportunities = async () => {
	const response = await baseApi.get(`/opportunity/all`);
	return response;
};
